import { render, staticRenderFns } from "./MyWatchlistsWrapper.vue?vue&type=template&id=085f7819&scoped=true&"
import script from "./MyWatchlistsWrapper.vue?vue&type=script&lang=js&"
export * from "./MyWatchlistsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MyWatchlistsWrapper.vue?vue&type=style&index=0&id=085f7819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f7819",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDivider,VIcon,VRow})
